const React = require('react')
const PropTypes = require('prop-types')
const log = require('log').create('contact form') // eslint-disable-line

class CaptchaField extends React.Component {

    static getCaptchaType() {
        return require('module/captcha/captcha').PREFERRED_CAPTCHA
    }

    componentDidMount() {
        requestAnimationFrame(() => this.renderCaptcha())
    }

    renderCaptcha() {
        const Captcha = require('module/captcha/captcha')

        Captcha.render({
            element: this.el,
            scale: false,
            onReceivedToken: this.props.onReceivedToken,
            onExpiredToken: this.props.onExpiredToken,
        })
    }

    render() {
        return (
            <div ref={(el) => { this.el = el }} />
        )
    }

}

CaptchaField.propTypes = {
    onReceivedToken: PropTypes.func,
    onExpiredToken: PropTypes.func,
}

module.exports = CaptchaField
